import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/models/User';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ValidationService } from 'src/app/services/validation.service';
import { UsersService } from 'src/app/services/users.service';
import { CryptoService } from '../../services/crypto.service';
import { StorageService } from 'src/app/services/storageService.service';

@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.page.html',
  styleUrls: ['./add-user-modal.page.scss'],
})
export class AddUserModalPage implements OnInit {

  public user: User;
  public isEditing: boolean;

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
    public userService: UsersService,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

  saveUser(event) {
    this.unfocusService.unfocus(event);
    if (this.validationService.isUserValid(this.user)) {
      if (this.isEditing) {
        var usersWithoutEditingLearner = this.userService.users.filter(x => x.userId != this.user.userId);
        if (usersWithoutEditingLearner.filter(x => String(x.email).toLowerCase() == String(this.user.email).toLowerCase()).length == 0) {
          this.userService.updateUser(this.user).then(x => {
            this.modalController.dismiss();
          });
        }
        else {
          this.validationService.createAlert("This user email already exists. Please add a unique email for this user.");
        }
      }
      else {
        if (this.userService.users.filter(x => String(x.email).toLowerCase() == String(this.user.email).toLowerCase()).length == 0) {

          this.userService.addUser(this.user).then(x => {
            this.modalController.dismiss();
          });
        }
        else {
          this.validationService.createAlert("This user email already exists. Please add a unique email for this user.");
        }
      }
    }
    else {
      this.validationService.alertForUserErrors(this.user);
    }
  }

  ecomUser() {
    if (this.cryptoService.decryptData(this.storageService.getItem('customerId')) == "1") {
      return true;
    }
    else {
      return false;
    }
  }

}
